// extracted by mini-css-extract-plugin
export default {"addUserSaasInventoryButton":"AddCellRenderer_addUserSaasInventoryButton__Zynxe"};